import { render, staticRenderFns } from "./ConsultaIndividualConfirmacao.vue?vue&type=template&id=0ca810b6&scoped=true"
import script from "./ConsultaIndividualConfirmacao.vue?vue&type=script&lang=js"
export * from "./ConsultaIndividualConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./ConsultaIndividualConfirmacao.vue?vue&type=style&index=0&id=0ca810b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca810b6",
  null
  
)

export default component.exports